import React from "react";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "./ui/dialog";
import { Separator } from "./ui/separator";
import { PopupCustomization } from "./notification/PopupCustomization";
import { useNotificationForm } from "../hooks/useNotificationForm";

const NotificationDialog = ({
  open,
  onOpenChange,
  onSave,
  setNeedToUpdate,
  notification,
  setNotification,
  notificationDialogOpen
}) => {
  const form = useNotificationForm({
    notification,
    open,
    onSave,
    onOpenChange
  });

  return (
    <Dialog open={open}
      onOpenChange={notificationDialogOpen}
      setNotification={setNotification}
    >
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl">
            {notification ?
              "Edit AI Notification Trigger" : "AI Notification Trigger"
            }
          </DialogTitle>
          {/*
          <DialogDescription>
            Define when and where the AI assistance pop-up should appear.
            The extension will listen for this page URL, and when detected,
            display a prompt offering tech support via AI.
          </DialogDescription>
          */}
        </DialogHeader>
        <Separator />
        <div className="grid gap-5 py-4">
          {/*
            <NotificationBasicSettings
              name={form.name}
              setName={form.setName}
              url={form.url}
              setUrl={form.setUrl}
              active={form.active}
              setActive={form.setActive}
            />

            <Separator className="my-2" />
          */}

          <PopupCustomization
            notification={notification}
            setNotification={setNotification}
            aiPrompt={form.aiPrompt}
            setAiPrompt={form.setAiPrompt}
            onOpenChange={onOpenChange}
            notificationDialogOpen={notificationDialogOpen}
            setNeedToUpdate={setNeedToUpdate}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationDialog;